import { PropsWithChildren } from "react";
import { PipecatClient } from "@pipecat-ai/client-js";
import { DailyTransport } from "@pipecat-ai/daily-transport";
import { PipecatClientProvider } from "@pipecat-ai/client-react";

const clientConfig = {
  transport: new DailyTransport(),
  enableMic: true,
  enableCam: false,
  baseUrl: process.env.REACT_APP_BACKEND_URL || "",
};

console.log("[PipecatProvider] Client config:", clientConfig);

if (!clientConfig.baseUrl) {
  console.error("[PipecatProvider] REACT_APP_BACKEND_URL is not configured");
}

const client = new PipecatClient(clientConfig);

export function PipecatProvider({ children }) {
  return (
    <PipecatClientProvider client={client}>{children}</PipecatClientProvider>
  );
}